import clsx from 'clsx';
import { type CsvExportState, csvExportPhaseLabel } from '../csvExport';

export function CsvExportProgress({ state }: { state: CsvExportState | null }) {
  if (!state) return null;

  const failed = state.phase === 'failed';
  const progressWidth = state.progress == null ? (failed ? 0 : 45) : Math.min(100, state.progress);

  return (
    <div
      className={clsx(
        'rounded-xl border bg-brand-surface p-4 shadow-sm',
        failed ? 'border-red-500/60' : 'border-brand-border'
      )}
      role="status"
      aria-live="polite"
    >
      <div className="flex items-center justify-between gap-4 text-xs">
        <div>
          <div
            className={clsx('font-semibold', failed ? 'text-red-300' : 'text-brand-text-primary')}
          >
            {csvExportPhaseLabel(state.phase)}
          </div>
          <div className="mt-1 text-brand-text-secondary">{state.label}</div>
        </div>
        <div className="text-right font-mono text-brand-text-secondary">
          <div>
            {state.progress == null ? (failed ? 'Failed' : 'Working...') : `${state.progress}%`}
          </div>
          {state.totalParts != null && (
            <div className="mt-1 text-[11px]">
              {state.completedParts ?? 0}/{state.totalParts} parts
            </div>
          )}
        </div>
      </div>
      {state.detail && (
        <p className={clsx('mt-3 text-xs', failed ? 'text-red-200' : 'text-brand-text-secondary')}>
          {state.detail}
        </p>
      )}
      <div
        className="mt-3 h-2 overflow-hidden rounded-full bg-brand-dark"
        role="progressbar"
        aria-valuemin={0}
        aria-valuemax={100}
        {...(state.progress == null ? {} : { 'aria-valuenow': state.progress })}
      >
        <div
          className={clsx(
            'h-full rounded-full transition-all duration-300',
            failed ? 'bg-red-400' : 'bg-brand-orange',
            state.progress == null && !failed && 'animate-pulse'
          )}
          style={{ width: `${progressWidth}%` }}
        />
      </div>
    </div>
  );
}
